import * as types from "../types/index";
import { core } from "./core";

export const getTemplates = () => {
  return core.API(
    "GET",
    `/report-templates`,
    types.GET_TEMPLATES,
    types.GET_TEMPLATES_SUCCESS,
    types.GET_TEMPLATES_FAILURE
  );
};

export const addTemplate = (data) => {
  return core.API(
    "POST",
    `/report-template`,
    types.ADD_TEMPLATE,
    types.ADD_TEMPLATE_SUCCESS,
    types.ADD_TEMPLATE_FAILURE,
    data
  );
};

export const getTemplate = (id) => {
  return core.API(
    "GET",
    `/report-template/${id}`,
    types.GET_TEMPLATE,
    types.GET_TEMPLATE_SUCCESS,
    types.GET_TEMPLATE_FAILURE
  );
};

export const putTemplate = (id, data) => {
  return core.API(
    "PUT",
    `/report-template/${id}`,
    types.PUT_TEMPLATE,
    types.PUT_TEMPLATE_SUCCESS,
    types.PUT_TEMPLATE_FAILURE,
    data
  );
};

export const deleteTemplate = (id) => {
  return core.API(
    "DELETE",
    `/report-template/${id}`,
    types.DELETE_TEMPLATE,
    types.DELETE_TEMPLATE_SUCCESS,
    types.DELETE_TEMPLATE_FAILURE
  );
};

export const getReportTable = (queryString) => {
  return core.API(
    "GET",
    `/reports/table${queryString ? `?${queryString}` : ""}`,
    types.GET_REPORT_TABLE,
    types.GET_REPORT_TABLE_SUCCESS,
    types.GET_REPORT_TABLE_FAILURE
  );
};

export const getAddonReportTable = (queryString) => {
  return core.API(
    "GET",
    `/addon/reports/table${queryString ? `?${queryString}` : ""}`,
    types.GET_ADDON_REPORT_TABLE,
    types.GET_ADDON_REPORT_TABLE_SUCCESS,
    types.GET_ADDON_REPORT_TABLE_FAILURE
  );
};

export const getFixedAddonReportTable = (queryString) => {
  return core.API(
    "GET",
    `/fixed-addon/reports/table${queryString ? `?${queryString}` : ""}`,
    types.GET_FIXED_ADDON_REPORT_TABLE,
    types.GET_FIXED_ADDON_REPORT_TABLE_SUCCESS,
    types.GET_FIXED_ADDON_REPORT_TABLE_FAILURE
  );
};

export const getPlanningReportTable = (queryString) => {
  return core.API(
    "GET",
    `/planning/reports/table${queryString ? `?${queryString}` : ""}`,
    types.GET_PLANNING_REPORT_TABLE,
    types.GET_PLANNING_REPORT_TABLE_SUCCESS,
    types.GET_PLANNING_REPORT_TABLE_FAILURE
  );
};

export const getSalaryExportHistory = () => {
  return core.API(
    "GET",
    `/salary-export-histories`,
    types.GET_SALARY_EXPORT_HISTORY,
    types.GET_SALARY_EXPORT_HISTORY_SUCCESS,
    types.GET_SALARY_EXPORT_HISTORY_FAILURE
  );
};

export const revertSalaryReport = (id) => {
  return core.API(
    "PUT",
    `/revert-salary-report/${id}`,
    types.GET_REVERT_SALARY_REPORT,
    types.GET_REVERT_SALARY_REPORT_SUCCESS,
    types.GET_REVERT_SALARY_REPORT_FAILURE
  );
};

export const getEmployeeReportTable = (queryString) => {
  return core.API(
    "GET",
    `/company/check-in-outs${queryString ? `?${queryString}` : ""}`,
    types.GET_EMPLOYEE_REPORT_TABLE,
    types.GET_EMPLOYEE_REPORT_TABLE_SUCCESS,
    types.GET_EMPLOYEE_REPORT_TABLE_FAILURE
  );
};
